import { isNumber } from 'lodash';

export function wrapperToMiliSeconds(value: number | string): number {
  if (!isNumber(value)) {
    return 0;
  }
  return Number(String(value).padEnd(13, '0'));
}
